import { FC } from "react";
import Select from "Components/Select";
import { Wrapper, SelectWrapper, FilterIntro } from "./EventsFilter.styled";

interface Props {
  onChange: any;
  catagory: any;
}

const EventsFilter: FC<Props> = ({ onChange, catagory }) => {
  return (
    <Wrapper>
      <FilterIntro> Events and Entertainment In Your Area &nbsp;</FilterIntro>
      <SelectWrapper>
        <Select
          options={[
            "Car boot and jumble sales",
            "Clubs / groups / societies",
            "Charity events",
            "Family fun days / events",
            "Film",
            "Markets",
            "On stage (music, theatre, performance)",
            "Sports / fitness / outdoors activities",
            "Students",
            "Other",
          ]}
          onChange={onChange}
          name="catagory"
          value={catagory}
          placeholderOverWrite="All events"
        />
      </SelectWrapper>
    </Wrapper>
  );
};

export default EventsFilter;
